import { AvanceBean } from './AvanceBean';
import { BaseBean } from './BaseBean';

export class ArchivoBean extends BaseBean {
  public id: number;
  public ruta: string;
  public nombre: string;
  public avance: AvanceBean;
  public tamanio: any;

}
